import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { QuestionnaireService } from '@app/shared/services/questionnaire.service';
import { environment } from '@environment/environment';
import { GuidanceNotesEditorDialogComponent } from '@shared/components/dialogs/guidance-notes-editor-dialog/guidance-notes-editor-dialog.component';
import { GuidanceNotesService } from '@shared/services/guidanceNotes.service';
import { GuidanceNote } from '@app/shared/models/guidanceNote';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'db-checkbox-wrapper',
  templateUrl: './checkbox-wrapper.component.html'
})

export class CheckboxWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef, static: true }) fieldComponent: ViewContainerRef;
  customFieldRadioDialogRefGN: MatDialogRef<GuidanceNotesEditorDialogComponent>;
  private guidanceNote = new GuidanceNote();
  constructor(private service: QuestionnaireService,  private guidanceNotesService: GuidanceNotesService, private dialog: MatDialog) {
    super();
  }

  ngOnInit() {
    this.guidanceNotesService.getGuidanceNote(this.id, this.model['questionnaireId']).subscribe(([ gnarray ]) => {
      if (gnarray !== undefined) {
        this.guidanceNote.id = gnarray.id;
        this.guidanceNote.questionId = gnarray.questionId;
        this.guidanceNote.questionnaireId = gnarray.questionnaireId;
        this.guidanceNote.text = gnarray.text;
        this.guidanceNote.title = gnarray.title;
      }
    });

    if (this.guidanceNote.questionId === '') {
      this.guidanceNote.questionId = this.id;
      this.guidanceNote.questionnaireId = this.model['questionnaireId'];
      this.guidanceNote.text = '';
      this.guidanceNote.title = 'AutoGeneratedTitleFromDocBuilder';
    }
  }

  getSector(id) {
    return this.service.getSector(id);
  }

  showSector() {
    return environment.showSectors;
  }

  updateSessionList() {
    this.guidanceNotesService.addSessionToCache(this.model["sessionID"], this.guidanceNote.text).subscribe();
  }

  editGuidanceNotesWindow() {
    this.customFieldRadioDialogRefGN = this.dialog.open(GuidanceNotesEditorDialogComponent, {
      panelClass: 'db-dialog',
      data: {
        guidanceNote: this.guidanceNote
      }
    });
  }

  checkIfGuidanceNotesExists() {
    if (this.guidanceNote.text === '' || this.guidanceNote.text === null) {
      return false;
    }
    return true;
  }
}
